import Users from 'dash/js/services/Users'

/**
 * @param {*} param0
 * @param {*} data
 */
export const retrieveInformations = ({ commit }) => {
  Users.retrieveInformations(response => commit('retrieveInformations', response.data))
}

/**
 * @param {*} param0
 * @param {*} data
 */
export const retrieveCompanies = ({ commit }) => {
  Users.retrieveCompanies(response => commit('retrieveCompanies', response.data))
}

/**
 * @param {*} param0
 * @param {*} data
 */
export const retrieveSettings = ({ commit }) => {
  Users.retrieveSettings(response => commit('retrieveSettings', response.data))
}
